import React from 'react'
import Header from "../componets/Header";
import Footer from "../componets/Footer";


import Banner from '../componets/about/Banner'
import Connect from '../componets/home/Connect'
import Grsf from '../componets/about/Grsf'
import Mission from '../componets/about/Mission'
import Methodology from '../componets/about/Methodology'
import Experience from '../componets/about/Experience'
import Founders from '../componets/about/Founders'
import Directors from '../componets/about/Directors'
import Expert from '../componets/about/Expert'
import Counter from '../componets/about/Counter'
import Snapshots from '../componets/about/Snapshots'
import Community from '../componets/about/Community'
import Logos from '../componets/about/Logos';

const page = () => {
    return (
        <>
            <div className="bs-aboutpage">
                <Header />
                <Banner />
                <Grsf />
                <Methodology />
                <Mission />
                {/* <Experience /> */}
                <Founders />
                <Logos/>
                <Directors />
                {/* <Expert />
                <Counter /> */}
                {/* <Snapshots /> */}
                <Community />
                <Connect />
                <Footer />
            </div>
        </>
    )
}

export default page